
const socials = {
    linkedin: "https://www.linkedin.com/in/Gablooblue",
    twitter: "https://twitter.com/TheGabLopez",
    github: "https://github.com/Gablooblue",
    email: "gabrielhenry.lopez@gmail.com"
}

export default socials
